/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* Backlink Explorer viewer — reads GS.site, calls /plugin/backlink-explorer/overview + /pages,
   renders the summary cards, the referring-domains table (expandable), and the most-linked pages. */
(function () {
  "use strict";
  var DAYS = 30;
  var SITE_DOMAIN = "";

  function normHost(h) { return String(h == null ? "" : h).toLowerCase().replace(/^www\./, ""); }

  /* A stored path must resolve to the page's OWN host (a site may track many subdomains),
     falling back to the site domain for older rows with no stored hostname. Never the app origin. */
  function absUrl(host, path) {
    var pth = String(path == null ? "/" : path);
    if (/^https?:\/\//i.test(pth)) return pth;          // already absolute
    if (pth.charAt(0) !== "/") pth = "/" + pth;
    var h = host || SITE_DOMAIN;
    return h ? "https://" + h + pth : pth;
  }
  /* Show the subdomain in the label only when it differs from the main site domain. */
  function pageLabel(host, path) {
    var pth = String(path == null ? "/" : path);
    return (host && normHost(host) !== normHost(SITE_DOMAIN)) ? host + pth : pth;
  }

  function api(q) {
    return GS.api("/plugin/backlink-explorer/" + q + (q.indexOf("?") < 0 ? "?" : "&") + "site=" + encodeURIComponent(GS.site || ""))
      .then(function (r) { return (r && r.data) ? r.data : r; });
  }
  function el(k) { return document.querySelector('[data-bl="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nf(n) { return (+n || 0).toLocaleString(); }
  function fmtDate(ts) {
    if (!ts) return "\u2014";
    var d = new Date(String(ts).replace(" ", "T"));
    if (isNaN(d)) return "\u2014";
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  }

  function card(v, l, s) {
    return '<div class="bl-card"><div class="v">' + esc(v) + '</div><div class="l">' + esc(l) + "</div>"
      + (s ? '<div class="s">' + esc(s) + "</div>" : "") + "</div>";
  }
  function renderCards(sum) {
    sum = sum || {};
    el("cards").innerHTML =
      card(nf(sum.referring_domains), TR('backli.g.referring_domains')) +
      card(nf(sum.referred_visits), TR('backli.g.referred_visits')) +
      card(nf(sum.new_domains), TT('back.m.new_this_period'), (sum.new_domains > 0 ? "+" + nf(sum.new_domains) + " domains" : ""));
  }

  function renderDomains(list) {
    var box = el("domains");
    if (!list || !list.length) { box.innerHTML = '<div class="bl-empty">'+TR('backli.f2.no_referring_sites_have_sent_visit')+'</div>'; return; }
    var rows = list.map(function (d) {
      return '<tr class="bl-row" data-domain="' + esc(d.domain) + '">'
        + '<td><span class="bl-dom"><i class="bi bi-chevron-right bl-chev"></i>' + esc(d.domain)
        +   (d.social ? ' <span class="bl-badge">social</span>' : "") + "</span></td>"
        + '<td class="num">' + nf(d.visits) + "</td>"
        + '<td class="num">' + nf(d.pages) + "</td>"
        + "<td>" + fmtDate(d.first_seen) + "</td>"
        + "<td>" + fmtDate(d.last_seen) + "</td></tr>"
        + '<tr class="bl-detail" hidden><td colspan="5"><div class="bl-empty">Loading\u2026</div></td></tr>';
    }).join("");
    box.innerHTML = '<table class="bl-table"><thead><tr><th>'+TR('backli.g.domain')+'</th>'
      + '<th class="num">'+TR('backli.g.visits')+'</th><th class="num">'+TR('backli.g.pages')+'</th><th>'+TT('back.js.first_seen')+'</th><th>'+TT('back.js.last_seen')+'</th></tr></thead>'
      + "<tbody>" + rows + "</tbody></table>";
  }

  function renderTopPages(list) {
    var box = el("toppages");
    if (!list || !list.length) { box.innerHTML = '<div class="bl-empty">'+TR('backli.f2.no_linked_pages_yet')+'</div>'; return; }
    box.innerHTML = '<div class="bl-top">' + list.map(function (p) {
      var href = absUrl(p.hostname, p.path);
      return '<div class="p"><a href="' + esc(href) + '" target="_blank" rel="noopener" title="' + esc(href) + '">' + esc(pageLabel(p.hostname, p.path)) + '</a><span class="n">' + nf(p.visits) + "</span></div>";
    }).join("") + "</div>";
  }

  function toggleDomain(row) {
    var detail = row.nextElementSibling;
    if (!detail || !detail.classList.contains("bl-detail")) return;
    var open = row.classList.toggle("open");
    detail.hidden = !open;
    if (open && !detail._loaded) {
      detail._loaded = true;
      var domain = row.getAttribute("data-domain");
      api("pages?days=" + DAYS + "&domain=" + encodeURIComponent(domain)).then(function (d) {
        if (d && d.site_domain) SITE_DOMAIN = d.site_domain;
        var pages = (d && d.pages) || [];
        var cell = detail.querySelector("td");
        if (!pages.length) { cell.innerHTML = '<div class="bl-empty">'+TR('backli.f2.no_specific_pages_recorded')+'</div>'; return; }
        cell.innerHTML = pages.map(function (p) {
          var href = absUrl(p.hostname, p.path);
          return '<div class="p"><a href="' + esc(href) + '" target="_blank" rel="noopener" title="' + esc(href) + '">' + esc(pageLabel(p.hostname, p.path)) + '</a>'
            + '<span class="n">' + nf(p.visits) + " visit" + (p.visits === 1 ? "" : "s") + "</span></div>";
        }).join("");
      }).catch(function () {
        detail._loaded = false;
        detail.querySelector("td").innerHTML = '<div class="bl-empty">Couldn\u2019t load pages.</div>';
      });
    }
  }

  function wireDomains() {
    var box = el("domains");
    if (!box || box._wired) return; box._wired = 1;
    box.addEventListener("click", function (e) {
      var row = e.target.closest(".bl-row");
      if (row) toggleDomain(row);
    });
  }
  function wireRange() {
    var box = el("range");
    if (!box || box._wired) return; box._wired = 1;
    box.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-days]");
      if (!b) return;
      DAYS = parseInt(b.getAttribute("data-days"), 10) || 0;
      Array.prototype.forEach.call(box.querySelectorAll("button"), function (x) { x.classList.toggle("on", x === b); });
      load();
    });
  }

  function load() {
    el("domains").innerHTML = '<div class="bl-empty">Loading\u2026</div>';
    api("overview?days=" + DAYS).then(function (d) {
      if (!d) return;
      SITE_DOMAIN = d.site_domain || SITE_DOMAIN;
      renderCards(d.summary);
      var ic=el("impcount"); if(ic){ ic.textContent = d.imported_count ? ("\u00b7 "+d.imported_count+" "+TT("bl.imp_stored")) : ""; }
      renderDomains(d.domains);
      renderTopPages(d.top_pages);
    }).catch(function () {
      el("domains").innerHTML = '<div class="bl-empty">Couldn\u2019t load backlinks.</div>';
    });
  }


  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }

  function apiPost(action, body) {
    return GS.api("/plugin/backlink-explorer/" + action + "?site=" + encodeURIComponent(GS.site || ""),
      { method: "POST", body: JSON.stringify(body || {}) });
  }

  function wireImport() {
    var btn = el("import"), clr = el("clearimp"), ta = el("csv"), msg = el("impmsg");
    if (btn && !btn._w) { btn._w = 1; btn.addEventListener("click", function () {
      var csv = (ta && ta.value || "").trim();
      if (!csv) { if (msg) msg.textContent = TT("bl.imp_empty"); return; }
      btn.disabled = true; if (msg) msg.textContent = TT("bl.imp_running");
      apiPost("import", { csv: csv }).then(function (r) {
        btn.disabled = false;
        var d = r && r.data;
        if (d && d.ok) {
          if (msg) msg.textContent = TT("bl.imp_done").replace("%n%", d.imported).replace("%s%", d.skipped).replace("%d%", d.domains);
          if (ta) ta.value = "";
          load();
        } else { if (msg) msg.textContent = TT("bl.imp_err"); }
      }).catch(function () { btn.disabled = false; if (msg) msg.textContent = TT("bl.imp_err"); });
    }); }
    if (clr && !clr._w) { clr._w = 1; clr.addEventListener("click", function () {
      if (!confirm(TT("bl.imp_confirm"))) return;
      apiPost("clearimported", {}).then(function () { if (msg) msg.textContent = TT("bl.imp_cleared"); load(); });
    }); }
  }

  function boot() { wireRange(); wireDomains(); wireImport(); load(); }
  function ready() { return window.GS && GS.api && GS.site; }
  if (ready()) boot();
  else {
    var t = setInterval(function () { if (ready()) { clearInterval(t); boot(); } }, 60);
    setTimeout(function () { clearInterval(t); }, 5000);
  }
})();
